import React, { useCallback, useMemo } from "react";
import { useFilterContext } from "../context/FilterContext";

const categories = [
  { name: "LOB", options: [] },
  { name: "Statuses", options: [] },
  { name: "TicketType", options: [] },
  { name: "CheckType", options: [] },

];

function CategoryFilter({ data }) {
  const { selectedCategories, updateFilters } = useFilterContext();

  const handleCategoryChange = useCallback(
    (category, option) => {
      const categoryOption = `${category}:${option}`;
      const updatedCategories = selectedCategories.includes(categoryOption)
        ? selectedCategories.filter((c) => c !== categoryOption)
        : [...selectedCategories, categoryOption];

      updateFilters(updatedCategories);
    },
    [selectedCategories]
  );

  const handleSortByChange = (e) => {
    updateFilters([...selectedCategories, `Sort by:${e.target.value}`]);
  };

  const filterCategoriesHandler = useMemo(() => {
    const statusOptions = Array.from(new Set(data.map((item) => item.displayStatus)));
    const lobOptions = Array.from(new Set(data.map((item) => item.lob)));
    const workflowtypeOptions = Array.from(
      new Set(data.map((item) => item.workflowtype))
    );
      
    const checkTypeOptions = Array.from(
      new Set(data.map((item) => item.metadata.CheckType))
    );    
    const assigneesOptions = Array.from(
      new Set(data.map((item) => item.assignedto))
    );

    return categories.map((category) => {
      if (category.name === "Statuses") {
        return { ...category, options: statusOptions };
      }
      if (category.name === "LOB") {
        return { ...category, options: lobOptions };
      }
      if (category.name === "Assignees") {
        return { ...category, options: assigneesOptions };
      }
      if (category.name === "TicketType") {
        return { ...category, options: workflowtypeOptions };
      }
      if (category.name === "CheckType") {
        return { ...category, options: checkTypeOptions };
      }      
      return category;
    });
  }, [data]);

  return (
    <div className="bg-background-3 h-full py-10 px-6">
      <h1 className="font-24-37-400 text-black-3">Filters</h1>
      <ul className="flex flex-col space-y-10 mt-4">
        {filterCategoriesHandler?.map((category) =>
          category.options?.length === 0 ? null : (
            <li key={category.name}>
              <h3 className="font-18-400-24 text-blue-2">{category.name}</h3>
              <ul>
                {category.options.map((option) => (
                  <li
                    key={`${category.name}:${option}`}
                    className="flex items-center gap-10"
                  >
                    <input
                      type="checkbox"
                      className="m-0 cursor-pointer"
                      id={`${category.name}:${option}`}
                      name={`${category.name}:${option}`}
                      value={`${category.name}:${option}`}
                      checked={selectedCategories.includes(
                        `${category.name}:${option}`
                      )}
                      onChange={() => handleCategoryChange(category.name, option)}
                    />
                    <label
                      className="font-18-400-24 text-blue-2 mb-0 cursor-pointer"
                      htmlFor={`${category.name}:${option}`}
                    >
                      {option}
                    </label>
                  </li>
                ))}
              </ul>
            </li>
          )
        )}
      </ul>

    </div>
  );
}

export default CategoryFilter;
